import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Impression } from '@nerdwallet/analytics/react/impression'; // Local Components

import ApplyNowWrapper from '../apply-now/apply-now';
import ProductDetailsToggle from '../product-details-toggle/product-details-toggle';
import MediaQuerySize from '../media-query-size/media-query-size';
import ProductImage from '../product-image/product-image';
import ProductLabel from '../product-label/product-label';
import ProductRating from '../product-rating/product-rating';
import ManagementFee from '../custom-components/management-fee';
import OptionsBrokerFeeCaption from '../custom-components/options-broker-fee-caption';

var ProductOverview =
/*#__PURE__*/
function (_Component) {
  _inherits(ProductOverview, _Component);

  function ProductOverview(props) {
    var _this;

    _classCallCheck(this, ProductOverview);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductOverview).call(this, props));
    _this.toggleExpandedOverlay = _this.toggleExpandedOverlay.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ProductOverview, [{
    key: "toggleExpandedOverlay",
    value: function toggleExpandedOverlay() {
      var size = this.mediaQuerySize.getSize();

      if (size !== 'sm') {
        this.props.toggleExpanded();
      }
    }
  }, {
    key: "renderCells",
    value: function renderCells() {
      var _this2 = this;

      var classMap = {
        label: ProductLabel,
        image: ProductImage,
        apply: ApplyNowWrapper,
        stars: ProductRating,
        managementFee: ManagementFee,
        optionsBrokerFeeCaption: OptionsBrokerFeeCaption
      };
      var _this$props = this.props,
          analytics = _this$props.analytics,
          data = _this$props.data,
          isExpanded = _this$props.isExpanded,
          customComponents = _this$props.customComponents,
          customToggleText = _this$props.customToggleText,
          mustClickToggleForDrawer = _this$props.mustClickToggleForDrawer,
          viewConfig = _this$props.viewConfig;
      return viewConfig.map(function (column, index) {
        var mediaQuery;
        var detailsToggle;

        if (index === 0) {
          mediaQuery = React.createElement(MediaQuerySize, {
            ref: function ref(c) {
              _this2.mediaQuerySize = c;
            }
          });
          detailsToggle = React.createElement("div", {
            key: "details-toggle",
            className: "toggle-expanded-in-product"
          }, React.createElement(ProductDetailsToggle, {
            analytics: _get(analytics, 'detailsDrawer'),
            isExpanded: isExpanded,
            customToggleText: customToggleText,
            onClick: mustClickToggleForDrawer ? _this2.toggleExpandedOverlay : function () {}
          }));
        }

        return React.createElement("td", {
          key: "overview-cell-".concat(column.title),
          className: classNames('product-table-cell', column.className, {
            'product-basics': index === 0
          })
        }, React.createElement("div", null, mediaQuery, column.content.map(function (contentItem, i) {
          if (contentItem.type === 'custom') {
            return React.createElement(customComponents[contentItem.component], _objectSpread({}, _this2.props, {
              config: contentItem.config,
              key: "custom-".concat(contentItem.component, "-").concat(index, "-").concat(i)
            }));
          }

          return React.createElement(classMap[contentItem.type], {
            data: contentItem.value ? _get(data, contentItem.value) : data,
            config: contentItem.config,
            customComponents: customComponents,
            key: ['custom-component', contentItem.type, index, i].join('-')
          });
        }), detailsToggle));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          analytics = _this$props2.analytics,
          data = _this$props2.data,
          mustClickToggleForDrawer = _this$props2.mustClickToggleForDrawer,
          productIndex = _this$props2.productIndex;

      if (!_isEmpty(analytics)) {
        return React.createElement(Impression, {
          className: "product-overview",
          onClick: mustClickToggleForDrawer ? function () {} : this.toggleExpandedOverlay,
          component: "tr",
          eventType: "product_impression",
          payload: {
            destination_url: _get(data, 'website'),
            element_position: productIndex,
            marketplace_institution_id: _get(data, 'institutionId'),
            marketplace_offer_id: _get(data, 'id'),
            marketplace_product_id: _get(data, 'productId'),
            marketplace_product_type: _get(data, 'productType'),
            monetizable: _get(data, 'isMonetizing') ? 'yes_assumed' : 'no',
            page_number: _get(analytics, 'productTable.pageNumber'),
            section_name: _get(analytics, 'productTable.sectionName'),
            section_position: _get(analytics, 'productTable.sectionPosition')
          },
          enabled: !_isEmpty(analytics)
        }, this.renderCells());
      }

      return React.createElement("tr", {
        className: "product-overview",
        onClick: mustClickToggleForDrawer ? function () {} : this.toggleExpandedOverlay
      }, this.renderCells());
    }
  }]);

  return ProductOverview;
}(Component);

ProductOverview.displayName = 'ProductOverview';
ProductOverview.propTypes = {
  analytics: PropTypes.shape({
    productTable: PropTypes.shape({
      pageNumber: PropTypes.number,
      sectionName: PropTypes.string,
      sectionPosition: PropTypes.number
    }),
    productTableAllOffers: PropTypes.shape({
      entityName: PropTypes.string,
      elementPosition: PropTypes.number,
      parentImpressionId: PropTypes.string,
      productType: PropTypes.string,
      sectionName: PropTypes.string,
      sectionPosition: PropTypes.number
    }),
    detailsDrawer: PropTypes.shape({
      entityName: PropTypes.string
    })
  }),
  productIndex: PropTypes.number,
  viewConfig: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  data: PropTypes.object,
  toggleExpanded: PropTypes.func,
  isExpanded: PropTypes.bool,
  customComponents: PropTypes.object,
  customToggleText: PropTypes.shape({
    show: PropTypes.string,
    hide: PropTypes.string
  }),
  mustClickToggleForDrawer: PropTypes.bool
};
export default ProductOverview;